"use client"

import { t } from "@/languages/i18n"
import { EventSubscriberType } from "@/types/types"
import { Form, FormInstance, Input, Radio, Select } from "antd"
import React from "react"

interface Props {
  form: FormInstance
  eventOptions?: { label: string; value: number }[]
  onFormChange: () => void
}

const EventSubscriberUpsertForm: React.FC<Props> = ({ form, eventOptions, onFormChange }) => {
  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={onFormChange}
      initialValues={{ type: "event", resolved: false }}
    >
      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="name" label={<span className="text-base font-medium">{t("Name")}</span>}>
          <Input placeholder={t("Enter name")} />
        </Form.Item>
        <Form.Item
          name="email"
          label={<span className="text-base font-medium">{t("Email")}</span>}
          rules={[{ type: "email", required: true, message: t("Vui lòng nhập email") }]}
        >
          <Input placeholder={t("Enter email")} />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          name="phone"
          label={<span className="text-base font-medium">{t("Phone")}</span>}
          rules={[
            { required: true, message: t("Vui lòng nhập số điện thoại") },
            {
              pattern: /^[+0-9\s]+$/,
              message: t("Số điện thoại chỉ được chứa các chữ số từ 0-9")
            }
          ]}
        >
          <Input placeholder={t("Enter phone")} />
        </Form.Item>
        <Form.Item name="event" label={<span className="text-base font-medium">{t("Event")}</span>}>
          <Select placeholder={t("Select event")} options={eventOptions} showSearch allowClear />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="resolved" label={<span className="text-base font-medium">{t("Resolved")}</span>}>
          <Radio.Group buttonStyle="solid">
            <Radio.Button value={false}>{t("False")}</Radio.Button>
            <Radio.Button value={true}>{t("True")}</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="type"
          label={<span className="text-base font-medium">{t("Type")}</span>}
          rules={[{ required: true, message: t("Vui lòng chọn hình thức sự kiện") }]}
        >
          <Select
            placeholder={t("Select type")}
            allowClear
            options={[
              { label: t("Chọn hình thức"), value: null },
              { label: t("Event"), value: EventSubscriberType.EVENT },
              { label: t("Newsletter"), value: EventSubscriberType.NEWSLETTER },
              { label: t("Other"), value: EventSubscriberType.OTHER },
            ]}
          />
        </Form.Item>
      </div>
    </Form>
  )
}

export default EventSubscriberUpsertForm
